export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/employee/record/index.js